import React from 'react';
import Button from '@material-ui/core/Button';
import Send from '@material-ui/icons/Send';
import { lightBlue } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const SubmitButton = withStyles(() => ({
  root: {
    color: lightBlue[50],
        backgroundColor: lightBlue[500],
        fontFamily: 'alternate_gothic_no2_d_regular',
        fontSize:'1.2rem',
    '&:hover': {
      backgroundColor: lightBlue[700],
    },
  },
}))(Button);

export default ({onClick, title, disableError = '', ...restProps}) => {
  if (disableError) {
    return (
      <Tooltip title={disableError}>
        <span>
          <SubmitButton
            {...restProps}
            disabled
            variant="contained"
            endIcon={<Send />}
            onClick={() => null}
            className='submit-button'
          >
            {title}
          </SubmitButton>
        </span>
      </Tooltip>
    );
  }
  return (
    <SubmitButton
      {...restProps}
      variant="contained"
      //endIcon={<Send />}
      onClick={onClick}
      className='submit-button login-submit-button'
    >
      {title}
    </SubmitButton>
  );
};